import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import Avatar from 'components/common/Avatar';
import { useAuth } from 'context/AuthContext';

const apiOrigin = (process.env.REACT_APP_API_URL || 'http://localhost:3004/api').replace(/\/api\/?$/, '');

const getAvatarSrc = avatarUrl => {
  if (!avatarUrl) return null;
  if (avatarUrl.startsWith('http://') || avatarUrl.startsWith('https://')) return avatarUrl;
  return `${apiOrigin}${avatarUrl}`;
};

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/auth/login');
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={getAvatarSrc(user?.avatarUrl)} name={user?.email || user?.name || 'User'} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as="div" className="text-700 fw-semibold pe-none">
            <FontAwesomeIcon icon="user" className="me-2 text-600" />
            {user?.email || user?.name || 'Nepoznat korisnik'}
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={handleLogout}>
            <FontAwesomeIcon icon="sign-out-alt" className="me-2 text-600" />
            Logout
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
